import React, {useState, useEffect} from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/free-solid-svg-icons'
import api from '../../api/index.js';
import {ChainSorter} from 'chainsorter';
import DatePicker from "react-datepicker";
import {callback} from '../../helpers.js';
import InputWrapper from '../forms/InputWrapper.js';
import Addrow from './add-row.js';
import Loadable from '../ui/loading/Loadable.js';

//import TaskSelector from './TaskSelector.js';

import './add.scss';

let data = [];

const AttendanceAddForm = (props) => {
	
	const [employees, setEmployees] = useState(false);
	
	const refresh = async () => {
		try {
			console.log("Resetting data");
			data = [];
			let d = (await api.get('employees')).filter(e => e['Visible'] == 'Y');
			setEmployees(ChainSorter(d).asc('FirstName', 'LastName').sort());
			
		} catch(e) {
			api.handleExceptions(e);
		};
	}
	
	
	useEffect(() => {
		if (employees === false) {
			refresh();
		}
	});

	// This one holds the data but not in state.
	// The individual ones have state and decide what to do based on props passed??
	// this one changes props based on if the topline changes
	// Each line has callbacks to update the data held here
	// Remember in the API - if swapping from one task another, to delete the old extra data associated with it one
	
	// The defaults
	const [date, setDate] = useState(props.date);
	const [task, setTask] = useState(false);
	const [hours, setHours] = useState(8);
	const [field, setField] = useState('');
	const [farm, setFarm] = useState('');
	const [employeedata, touchEmployeeData] = useState(0);
	const touch = () => { touchEmployeeData(employeedata + 1); }

	const defaultChange = (fieldname, value) => {
		console.log("defaultChange", fieldname, value);
		let past = false;
		let fn = false;
		switch(fieldname) {
			case 'date':
				fn = setDate;
				break;
			case 'hours':
				past = hours;
				fn = setHours;
				break;
			case 'field':
				past = field;
				fn = setField;
				break;
			case 'farm':
				past = farm;
				fn = setFarm;
				break;
			case 'task':
				past = task;
				fn = setTask;
				break;
			default:
				break;
		}
		for(let i=0; i < data.length; i++) {
			if (data[i][fieldname] == past) { // If it's the same as the default, update it
				data[i][fieldname] = value;
			}
		}
		callback(fn, [value]);
		touch();
	}

	const defaultChangeFieldAndFarm = (e) => {
		if (e === null)
			e = {'FarmID': 0, 'FieldID': 0};

		for(let i=0; i < data.length; i++) {
			if (data[i]['field'] == field && data[i]['farm'] == farm) { // If it's the same as the default, update it
				data[i]['field'] = e['FieldID'];
				data[i]['farm'] = e['FarmID'];
			}
		}
		setField(e['FieldID']);
		setFarm(e['FarmID']);
		touch();
	}



	const dataChange = (row, prop, value) => {
		data[row][prop] = value;
		touch();
	}


	const duplicaterow = (i) => {
		data.splice(i + 1, 0, {
			'date': data[i].date,
			'employee': data[i].employee,
			'task': data[i].task,
			'hours': 0,
			'field': data[i].field,
			'farm': data[i].farm
		});
		touch();
	}

	const addrow = (e) => {
		e.preventDefault();
		data.push({
			'date': date,
			'employee': 0,
			'task': task,
			'hours': hours,
			'field': field,
			'farm': farm
		});
		touch();
	}

	const getTasks = async () => {
		try {
			return await api.getsoft('tasks');
		} catch(e) {
			api.handleExceptions(e);
		};
	}

	const submitAttendance = async (e) => {
		e.preventDefault();
		// Figure out which ones have data in, and package them up for sending
		let out = [];
		let tasklist = await getTasks();
		for(let i=0; i < data.length; i++) {
			let line = data[i];
			if (line['task'] === false) continue; // Skip entries with no tasks
			let task = null;
			for(let t=0; t < tasklist.length; t++) {
				if (tasklist[t]['TaskID'] == line['task']['TaskID']) {
					task = tasklist[t];
					break;
				}
			}

			if (task['RequireField'] == 1) {// Some tasks don't require fields (sprays, etc.)
				if ((line['field'] == "" || line['field'] === false || line['field'] === 0) && (line['farm'] == "" || line['farm'] === false || line['farm'] === 0))continue; // Skip entries with no field
			}
			if (parseFloat(line['hours']) == 0) continue; // Skip entries with no hours
			if (typeof date == 'object') { // Dates weren't coming through right, so I'm going to pull it right from the state
				line['date'] = date.api();
			} else {
				line['date'] = date;
			}
			out.push(line);
		}
		
		if (out.length === 0) { // Nothing to save
			api.error("Nothing to save.");
			return;
		}
		
		console.log("data", out);
		// Send to the server...  If successfull, redirect to the attendance page.  If not, stay here and maybe highlight what's wrong?
		try {
			let response = await api.post('attendance', {'data': JSON.stringify(out)});
			
			// Redirect to a different page
			callback(props.onAdded, []);
			
		} catch(e) {
			api.handleExceptions(e);
			// Should I highlight what's wrong?
		};
	}



	// Load in the default values for the employees
	if (data.length == 0 && employees !== false && employees.length > 0) {
		for(var i=0; i < employees.length; i++) {
			data.push({
				'date': date,
				'employee': employees[i]['EmployeeID'],
				'task': task,
				'hours': hours,
				'field': field,
				'farm': farm
			});
		}
	}
	
	let rows = [];
	for(var i=0; i < data.length; i++) {
		if (data[i] === false) continue;
		//console.log(data[i]);
		rows.push(<div key={"row" + i} >
			<Addrow 
				onChange={dataChange.bind(this, i)} 
				date={date} 
				employee={data[i]['employee']} 
				task={data[i]['task']}
				hours={data[i]['hours']} 
				field={data[i]['field']} 
				farm={data[i]['farm']}
				onFarmAndFieldChange={false}
			/>
			<div className="extra-row"><button className="block plus" type="button" title={"Add another entry for this employee"} onClick={duplicaterow.bind(this, i)}>
				<FontAwesomeIcon icon={faPlus}/>
			</button></div>
		</div>);
	}

	// On change of the top,
	// Go through the data and figure out which children should be changed.. If they're different from the old data
	
	// Also support adding a row and removing a row
	/*
	<p>Top row (*defaults sort of)</p>
		<p>Table with a row for each active employee</p>
		<p>These rows should be their own component.  But should I use the same component for the top row?  Uncertain.</p>
		<p>If I move date out of the table, there will be less in it.  Also that makes sense logically I think.</p>
		<p>Changes to the date can effect the field table.  Some fields might not exist for a given date.  How to deal with that?</p>
		<p>Changes to the date can effect the task table.  Some tasks ask you to specify rows, which require a field (see above).  How to deal with that?</p>
		*/
	return <form className="add-form">
		<InputWrapper label="Date" info="The date this attendance form is for.">
			&nbsp;<DatePicker
				className="Date"
				selected={date}
				onChange={defaultChange.bind(this, 'date')}
			/>
		</InputWrapper>
		<div className="defaults">
			<Addrow onChange={defaultChange} onFarmAndFieldChange={defaultChangeFieldAndFarm} date={date} task={task} hours={hours} field={field} farm={farm} employee={false} />
		</div>
		<Loadable ready={employees !== false} className="entries">
			{rows}
		</Loadable>
		<button className="block" onClick={addrow}><FontAwesomeIcon icon={faPlus} /> Add another row</button>
		<button className="block" onClick={submitAttendance}>Save</button>
	</form>;
}
export default AttendanceAddForm;